import styled from "styled-components";
import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import { DataContext } from "../../contexts/DataContext";
import { APIContext } from "../../contexts/APIContext";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";



const Main = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Title = styled.div`
  display: flex;
  border-bottom: 1px solid #dadde1;
  box-sizing: border-box;
  font-size: 1.5em;
  width: 100%;
  padding: 0.5em;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ActionPanel = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1em;
  /* padding: 1em; */
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  height: 100%;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const Input = styled.input`
  background-color: #1f222b;
  border-radius: 4px;
  border: none;
  padding: 1em;
  margin-bottom: 1em;
  outline: none;
  color: #fff;
  width: 85%
`;

const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#202731"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 5%;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 60px;
  width: 120px;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;



export default function CommsScorecard({ game }) 
{
    const { commID } = useParams();
    const { nextGame, lastGame } = useContext(DataContext);
    const { updateComms } = useContext(APIContext);
    const initialRounds = Array.from({ length: 12 }, () => ({ score: ""}));
    const period = [...(game?.live_data?.periods || [])].sort(
    (a, b) => b.number - a.number
  )[0];
    const updateDeduction = (viewerIndex, value) => {
    const newScorecard = [...scorecard]
    newScorecard[viewerIndex].deductions = value;
    setScorecard(newScorecard)
  }
  const { previewGraphic, animateGraphic, animateOffGraphic, setSelectedGraphic, selectedGraphic } = useContext(GraphicsContext);
  const [scorecard, setScorecard] = useState([]);

    useEffect(() => {
        const index = parseInt(commID);
        const currentComm = game?.commentators?.[index];

        if (currentComm?.scorecard) {
            setScorecard(currentComm.scorecard);
        } else {
            setScorecard([
                { rounds: initialRounds, deductions: "" },
                { rounds: initialRounds, deductions: "" },
            ]);
        }
    }, [game, commID]);
  const updateScore = (viewerIndex, roundIndex, newValue) => {
      const newScorecard = [...scorecard];
      const updatedViewer = { ...newScorecard[viewerIndex]};
      const updatedRounds = [...updatedViewer.rounds];
      updatedRounds[roundIndex] = { ...updatedRounds[roundIndex], score: newValue };
      updatedViewer.rounds = updatedRounds
      newScorecard[viewerIndex] = updatedViewer;

      setScorecard(newScorecard);

      let updatedCommentators = [...game.commentators];
      updatedCommentators[commID] = {
        ...updatedCommentators[commID],
        scorecard: newScorecard
      };
      updateComms({id: game._id, commentators: updatedCommentators})
  };


    return (
   
    <div className="bg-background font-manrope font-bold w-[100%] h-[80dvh] justify-center items-center no-scrollbar flex-col overflow-y-auto flex">
        <div className="flex flex-row items-space-evenly w-[100%]">
        </div>
      <div className="flex-col flex items-center justify-start w-[100%] h-full py-5">
      Current Round - Round {period.number}
        {[...Array(game?.number_of_rounds || 12)].map((_, i) => (
        <div key={i} 
        className="flex-col w-[100%] p-3 flex items-center rounded"
        style={{
          opacity: (i < period.number ) ?
          "100%" :
          "50%",
        }}>  
        <div className="flex my-1 py-5 w-[90%] bg-section justify-between items-center rounded"
        style={{
        border: ( i+1 === period.number ) ?
        "2px solid #0adb93" 
        : "none",
        }}>
        <input
        type="number"
        value={scorecard[0]?.rounds[i]?.score || ""}
        onChange={(e) => updateScore(0, i, e.target.value)}
        className="w-[15%] h-[6dvh] p-1 mx-5 bg-[#702121ff] text-white text-center rounded"
        />
        <span className="text-xs text-center" >Round {i+1}</span>
        <input
        type="number"
        value={scorecard[1]?.rounds[i]?.score || ""}
        onChange={(e) => updateScore(1, i, e.target.value) }
        className="w-[15%] h-[6dvh] p-1 mx-5 bg-[#1a1a58ff] text-white text-center rounded"
        />
        </div>
        </div>
      ))}
      </div>
    </div>
    );
}


